module.exports = __webpack_public_path__ + "static/media/om_eyebrowshape_s_vector.8afcc9da.svg";